import { render } from "./SideMenuButton.vue?vue&type=template&id=4f7c7c57&scoped=true"
import script from "./SideMenuButton.vue?vue&type=script&lang=js"
export * from "./SideMenuButton.vue?vue&type=script&lang=js"

import "./SideMenuButton.vue?vue&type=style&index=0&id=4f7c7c57&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2026\\tokyo-shoseki\\R9 Site Maintenance January 2026\\08k_sekts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7c7c57"]])

export default __exports__